<template>
  <div>
    <v-form>
      <v-card color="grey lighten-4">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Bilet İade {{baslik_mesaji}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="iadekaydet()" class="white--text" flat>Kaydet
                <v-icon right dark>save</v-icon>
              </v-btn>
              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile v-if="iadeiptalbtn" @click="iadeiptal()">
                    <v-list-tile-title>İade Sil</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="yeniiadebtn" @click="yeniiadeekle()">
                    <v-list-tile-title>Yeni İade Ekle</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="sayfakapatiade()">
                    <v-list-tile-title>İptal</v-list-tile-title>
                  </v-list-tile>


                </v-list>
              </v-menu>
            </v-toolbar>


          </v-flex>



          <v-container>
            <v-layout row="" wrap="">
              <v-flex pa-1 xs12 sm6 md3>
                <v-card class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <tarihcomp :etiket="'İade Tarihi'" :tabindex="'1'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.IadeTarihi"
                          v-model="BiletIade.TarihBilgileri.IadeTarihi"></tarihcomp>
                        <v-autocomplete hide-details tabindex="2" append-icon="search" label="İade Hesap Kodu" :loading="loading"
                          :items="statecari" clearable="" item-text="text" cache-items="" item-value="id"
                          :search-input.sync="search" v-model="BiletIade.GenelBilgileri.Cari.Kod"></v-autocomplete>
                        <tarihcomp :etiket="'İade Vade'" :tabindex="'3'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.VadeTarihi"
                          v-model="BiletIade.TarihBilgileri.VadeTarihi"></tarihcomp>
                        <v-layout>
                          <tarihcomp :etiket="'İade Fat.Tar'" :tabindex="'4'" v-bind:defaultvalue="'ok'" v-bind:value="BiletIade.TarihBilgileri.IadeFaturaTarihi"
                            v-model="BiletIade.TarihBilgileri.IadeFaturaTarihi"></tarihcomp>
                          <v-text-field hide-details="" tabindex="5" v-model="BiletIade.FaturaBilgileri.IadeFaturaNo"
                            label="İade Fat.No"></v-text-field>
                        </v-layout>
                        <v-text-field hide-details="" tabindex="6" v-model="BiletIade.FaturaBilgileri.IadeFaturaGelenBelgeNo"
                          label="İade Fatura Belge No"></v-text-field>
                        <v-checkbox label="Ödendi mi?" tabindex="7" v-model="BiletIade.OdemeBilgileri.Odeme"
                          hide-details=""></v-checkbox>
                        <v-text-field hide-details="" tabindex="8" v-model="BiletIade.FaturaBilgileri.DekontNo" label="Dekont No"></v-text-field>
                        <v-text-field tabindex="9" v-model="BiletIade.GenelBilgileri.KesenKisi" hide-details="" label="İadeyi Alan Kişi"></v-text-field>
                        <v-text-field tabindex="10" v-model="BiletIade.FaturaBilgileri.ServisFaturaNo" hide-details=""
                          label="Servis Fatura No"></v-text-field>
                        <v-textarea label="Notlar" tabindex="11" v-model="BiletIade.GenelBilgileri.Notlar" hide-details=""></v-textarea>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 sm6 md3>
                <v-card color="grey-lighten-4">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <v-text-field hide-details="" tabindex="12" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur1"
                          label="Parkur1"></v-text-field>
                        <v-text-field hide-details="" tabindex="13" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur2"
                          label="Parkur2"></v-text-field>
                        <v-text-field hide-details="" tabindex="14" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur3"
                          label="Parkur3"></v-text-field>

                        <v-text-field hide-details="" tabindex="15" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur4"
                          label="Parkur4"></v-text-field>
                        <v-text-field hide-details="" tabindex="16" v-model="BiletIade.GenelBilgileri.Parkurlar.Parkur5"
                          label="Parkur5"></v-text-field>


                        <v-radio-group label="İade Uçuş" tabindex="17" v-model="BiletIade.GenelBilgileri.IadeUcusTip">
                          <v-radio label="Gidiş" value="G"></v-radio>
                          <v-radio label="Dönüş" value="D"></v-radio>
                          <v-radio label="Tamamı" value="T"></v-radio>
                        </v-radio-group>
                        <v-radio-group label="Dekont/Gider Pusulası" tabindex="18" v-model="BiletIade.DigerBilgileri.DekontPusula">
                          <v-radio label="Dekont Bas" value="D"></v-radio>
                          <v-radio label="Gider Pusulası Bas" value="P"></v-radio>
                        </v-radio-group>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex  pa-1 xs12 sm12 md6>
                <v-card color="grey-lighten-4">
                  <v-card flat="">
                    <v-card-actions>

                <v-layout  justify-space-between column>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Toplam'" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Dvz.Al.Tutar'" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutarAlisDoviz"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :aktif="'true'" v-model="BiletIade.TutarBilgileri.NetTutar.NetTutarSatisDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Cezasız Tutar'" :aktif="'true'" v-model="BiletIade.CezasızTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>

                      <parainput :etiket="'Tutar'" :tabdeger="19" v-model="BiletIade.TutarBilgileri.Tutar.Tutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>

                      <parainput :etiket="'Dvz.Al.Tutar'" :tabdeger="20" v-model="BiletIade.TutarBilgileri.Tutar.TutarAlisDoviz"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>

                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="21" v-model="BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>

                      <parainput :etiket="'Ceza'" :tabdeger="22" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>

                      <parainput :etiket="'Dvz.Al.Tutar'" :tabdeger="23" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>

                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="24" v-model="BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>

                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Alan Vergisi'" :tabdeger="25" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Dvz.Al.Tutar'" :tabdeger="26" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>
                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="27" v-model="BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>

                      <parainput :etiket="'Yakıt Fiyat Farkı'" :tabdeger="31" v-model="BiletIade.TutarBilgileri.YffTutar.YFFTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'İade Servis Ücreti'" :tabdeger="32" v-model="BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'KA Vergisi'" :tabdeger="33" v-model="BiletIade.TutarBilgileri.KaTutar.KaTutar"
                        :autocomplete="'autocomplete'"></parainput>

                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Servis Ücreti'" :tabdeger="34" v-model="BiletIade.TutarBilgileri.ServisTutar.ServisTutar"
                        :autocomplete="'autocomplete'"></parainput>

                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'İskonto'" :tabdeger="35" v-model="BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>

                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="36" v-model="BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Diğer Servis'" :tabdeger="37" v-model="BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="38" v-model="BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Vade Farkı'" :tabdeger="39" v-model="BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <doviztutarcomp :etiket="'Dvz.Sat.Tutar'" :tabdeger="40" v-model="BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz"
                        :autocomplete="'autocomplete'"></doviztutarcomp>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'HY Tutar'" :tabdeger="41" v-model="BiletIade.OdemeBilgileri.HavayoluTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Kredili Tutar'" :tabdeger="42" v-model="BiletIade.OdemeBilgileri.KrediliTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>


                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Döviz Tutarı'" :tabdeger="43" v-model="BiletIade.OdemeBilgileri.KrediliDvzTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Peşin Tutar'" :tabdeger="44" v-model="BiletIade.OdemeBilgileri.PesinTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Döviz Tutarı'" :tabdeger="45" v-model="BiletIade.OdemeBilgileri.PesinDvzTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Kredili Kartlı Tutar'" :tabdeger="46" v-model="BiletIade.OdemeBilgileri.KrediKartTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Döviz Tutarı'" :tabdeger="47" v-model="BiletIade.OdemeBilgileri.KrediKartDvzTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <v-text-field hide-details="" tabindex="48" v-model="BiletIade.OdemeBilgileri.Analiz.AnalizKod"
                        label="Analiz Kod"></v-text-field>
                    </v-flex>


                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Analiz Tutar'" :tabdeger="49" v-model="BiletIade.OdemeBilgileri.AnalizTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>


                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Analiz Dvz. Tutar'" :tabdeger="50" v-model="BiletIade.OdemeBilgileri.AnalizDvzTutar"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 sm4 md4>
                      <v-text-field hide-details="" tabindex="51" v-model="BiletIade.OdemeBilgileri.Analiz1.AnalizKod"
                        label="Analiz Kod1"></v-text-field>
                    </v-flex>

                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Analiz Tutar1'" :tabdeger="52" v-model="BiletIade.OdemeBilgileri.AnalizTutar1"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                    <v-flex xs4 sm4 md4>
                      <parainput :etiket="'Analiz Dvz Tutar'" :tabdeger="53" v-model="BiletIade.OdemeBilgileri.AnalizDvzTutar1"
                        :autocomplete="'autocomplete'"></parainput>
                    </v-flex>

                  </v-layout>

                </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>


        </v-layout>
      </v-card>
    </v-form>


    <v-dialog v-model="dialogkisamesaj" width="500">

      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Uyarı!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{this.kisamesaj}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogkisamesaj = false">
            Tamam
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-dialog v-model="loadingdialog" hide-overlay persistent width="400">
      <v-card color="primary" dark>
        <v-card-text>
          Biletiniz Getiriliyor, Lütfen Bekleyiniz...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>



    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import dovizinput from '../customcomp/dovizinput'
  import tarihcomp from '../customcomp/tarihim'
  import cariaracomp from '../customcomp/cariaracomp'
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
    import helpers from "@/components/app/customcomp/helpers.js"



  export default {
    data() {
      return {


        BiletIade: {
          GenelBilgileri: {
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: '',
            Sirano: '',
            UcusTip: '',
            Cari: {
              Kod: ''
            },
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: ''
            },
            IadeUcusTip: '', //enum
            KesenKisi: '',
            Masraf: {
              Code: ''
            },
            Referans: {
              Kod: ''
            },
            Crs: '', // enum
            Notlar: '',
            IadeSirano: 0
          },
          TarihBilgileri: {
            IadeTarihi: null,
            VadeTarihi: null,
            IadeFaturaTarihi: null
          },
          FaturaBilgileri: {
            IadeFaturaNo: null,
            DekontNo: null,
            ServisFaturaNo: null,
            IadeFaturaGelenBelgeNo: null
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: null
            },
            Kur: 0,
            CezasizTutar: 0,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            YffTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0,
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            IadeServisTutar: {
              IadeServisTutar: 0,
              IadeServisDoviz: 0,
              IadeServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },
          OdemeBilgileri: {
            Odeme: false,
            KrediliTutar: 0,
            KrediliDvzTutar: 0,
            PesinTutar: 0,
            PesinDvzTutar: 0,
            KrediKartTutar: 0,
            KrediKartDvzTutar: 0,
            HY: 0,
            GSA: 0,
            HavayoluTutar: 0,
            Analiz: {
              AnalizKod: ''
            },
            AnalizTutar: 0,
            AnalizDvzTutar: 0,
            Analiz1: {
              AnalizKod: ''
            },
            AnalizTutar1: 0,
            AnalizDvzTutar1: 0,
          },
          DigerBilgileri: {
            IadeTanim: null,
            Entegre: null,
            ExIcDis: null,
            CkLogId: null,
            ParkurTip: null,
            KKEnt: null,
            IadeDekontID: null,
            IadeMaliyetDekontID: null,
            IadeSapEntegre: null,
            IadeMaliyetSapEntegre: null,
            // public Guid EntegrasyonID { get; set; }
            ServisFark: false,
            DekontPusula: '', //enum
            AlisEntegre: null,
          },
          LoginBilgileri: {
            UserID: null,
            Email: null,
            MusteriKodu: null,
            SigortaSirket: null,
            CariSirket: null,
            BiletSirket: null,
            CoperSirket: null
          }
        },
        SatisSekli: null,
        ToplamTutar: 0,
        CezasızTutar: 0,
        search: '',
        Referans: [],
        iadeiptalbtn: false,
        yeniiadebtn: false,
        baslik_mesaji: '',

        loadingdialog: false,
        dialog_baslik: '',

        m: false,
        k: false,
        progress: false,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],

        search: '',
        loading: false,


        doviztipi: [],


        kisamesaj: '',
        dialogkisamesaj: false,

        guncellebuton: false,
        masrafmerkezi: [],
        taksitsayiservis: [],
        taksitsayitahsilat: [],
        itemsbanka: [],
        bolumler: [],
        dictionary: {
          custom: {
            carikod: {
              required: () => 'Bu alan boş bırakılamaz',

            },
            cariseciniz: {
              required: () => 'Bu alan boş bırakılamaz',

            },
            unvan: {
              required: () => 'Bu alan boş bırakılamaz',
              min: () => 'En az 4 haneli olmalı',
            },

          }
        },

        kaydetbuton: false,
        datesatistarihi: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      kartbilgisigetir(kartno) {
        this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = kartno
        this.kredikartdialog = false
      },
      kurgetir(tarih, kod) {
        var params1 = {
          Tarih: tarih,
          DovizKod: kod
        }
        if (tarih != null && tarih != '') {
          this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.BiletAyrintiliOdeme.Kur = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }
      },

      sayfakapatiade() {

        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
          '&biletno=' +
          this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip
        window.open(url, '_self')
      },
      yeniiadeekle() {
        var url = '#/bilet/biletiade/id?' + 'isl=yeniiade&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
          '&biletno=' + this.BiletIade.GenelBilgileri.BiletNo + '&formno=' + this.BiletIade.GenelBilgileri.Formno
        window.open(url, '_target')
        window.location.reload(false);

      },

      ekle: ekle,
      carigetir: carigetir,
      iadekaydet: iadekaydet,
      iadeiptal: iadeiptal,
      tutarTopla,
      dovizTutarTopla

    },
    beforeMount: beforeMount,

    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp,
      'cariaracomp': cariaracomp,
      doviztutarcomp

    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      loadingdialog(val) {
        if (!val) return
        setTimeout(() => (this.loadingdialog = false), 4000)
      },

      'BiletIade.TutarBilgileri.Tutar.Tutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (value1) {
        this.tutarTopla();
      },

      'BiletIade.TutarBilgileri.TaxTutar.TaxTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.YffTutar.YFFTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.CezaTutar.CezaTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.KaTutar.KaTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar': function (value1) {
        this.tutarTopla();
      },
      'BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz': function (value1) {
        this.BiletIade.TutarBilgileri.Tutar.Tutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar': function (value1) {
        this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (value1) {
        this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz': function (value1) {
        this.BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (value1) {
        this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz': function (value1) {
        console.log('ieaeiaei')
        this.BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar = this.BiletIade.TutarBilgileri.Kur * value1
      },
      'BiletIade.TutarBilgileri.Tutar.TutarAlisDoviz': function (value1) {
        this.dovizTutarTopla();
      },
      'BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz': function (value1) {
        this.dovizTutarTopla();
      },
      'BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar': function (value1) {
        this.dovizTutarTopla();
      }
    }
  }



  function iadeiptal() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var paramsiade = {
      SirketKodu: credentials.SirketKodu,
      BiletNo: this.BiletIade.GenelBilgileri.BiletNo,
      FormNo: this.BiletIade.GenelBilgileri.Formno,
      SiraNo: this.BiletIade.GenelBilgileri.Sirano,
      IadeTarihi: this.BiletIade.TarihBilgileri.IadeTarihi,
    }

    this.$http.post(auth.API_URL + 'api/Ticket/RefundDelete', paramsiade, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
        '&biletno=' +
        this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip


      setTimeout(function () {
        window.open(url, '_self')
        // window.location.reload(false);
      }.bind(this), 5000)


    }, (response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    })
  }

  function iadekaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.BiletIade.GenelBilgileri.SirketKodu = credentials.SirketKodu

    var paramsbilet = this.BiletIade

    this.$http.post(auth.API_URL + 'api/Ticket/RefundAdd', paramsbilet, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true


      var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.BiletIade.GenelBilgileri.HavaYoluKodu +
        '&biletno=' +
        this.BiletIade.GenelBilgileri.BiletNo + '&ucustipi=' + this.BiletIade.GenelBilgileri.UcusTip


      setTimeout(function () {
        window.open(url, '_self')
        // window.location.reload(false);
      }.bind(this), 5000)

    }, (response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true

      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    })

  }

  function carigetir(v) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      q: escape(v),
      c: credentials.SirketKodu
    }
    if (v.length >= 1) {
      this.loading = true
      this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.statecari = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
      this.loading = false
    }
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bolumler = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/Analysis/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress = false
      this.analizitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })




    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      }
    })




    this.progress = true

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsparkur = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false
        this.snackbar = true
      }
    })




    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.classitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
      }
    })



    this.$http.post(auth.API_URL + 'api/Reference/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Referans'
        this.snackbar = true
      }
    })


    if (this.$route.query.isl == 'iadeget') {

      var iadeparams = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.$route.query.biletno,
        HavaYoluKodu: this.$route.query.hyolukod,
        FormNo: this.$route.query.formno,
        Sirano: this.$route.query.sirano,
      }

      this.$http.post(auth.API_URL + 'api/Ticket/RefundLoad', iadeparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.BiletIade = response.body
        this.BiletIade.GenelBilgileri.UcusTip = this.$route.query.ucustipi
        this.BiletIade.TutarBilgileri.CezasizTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar + this.BiletIade
          .TutarBilgileri.CezaTutar.CezaTutar
        this.iadeiptalbtn = true
        this.yeniiadebtn = true
        this.biletnodisabled = false

        var seciliitems = [{
          text: response.body.GenelBilgileri.Cari.Kod + '-' + response.body.GenelBilgileri.Cari.Unvan,
          id: response.body.GenelBilgileri.Cari.Kod
        }]

        this.statecari = seciliitems

      }, (response) => {
        if (response.status === 0) {
          console.log('')
        } else {
          console.log('')
        }
      })
    } else if (this.$route.query.isl == 'yeniiade') {

      this.iadeiptalbtn = false
      this.yeniiadebtn = false
      this.BiletIade.GenelBilgileri.BiletNo = this.$route.query.biletno
      this.BiletIade.GenelBilgileri.Formno = this.$route.query.formno
      this.BiletIade.GenelBilgileri.HavaYoluKodu = this.$route.query.hyolukod
      this.BiletIade.GenelBilgileri.UcusTip = this.$route.query.ucustipi

      var biletparams = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.$route.query.biletno,
        HavaYoluKodu: this.$route.query.hyolukod,
        UcusTipi: this.$route.query.ucustipi
      }

      this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        var seciliitems = [{
          text: response.body.GenelBilgileri.MusteriKodu.Kod + '-' + response.body.GenelBilgileri.MusteriKodu.Unvan,
          id: response.body.GenelBilgileri.MusteriKodu.Kod
        }]

        this.statecari = seciliitems
        this.BiletIade.GenelBilgileri.Cari.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
        this.BiletIade.GenelBilgileri.Parkurlar = response.body.GenelBilgileri.Parkurlar


        // tutar bilgilerini yazalım

        if (response.body.TutarBilgileri.Kur < 1) {
          this.BiletIade.TutarBilgileri.Kur = 1
        } else {
          this.BiletIade.TutarBilgileri.Kur = response.body.TutarBilgileri.Kur
        }

        this.BiletIade.TutarBilgileri.Tutar.Tutar = response.body.TutarBilgileri.Tutar.Tutar
        this.BiletIade.TutarBilgileri.AlanVergiTutar = response.body.TutarBilgileri.AlanVergiTutar
        this.BiletIade.TutarBilgileri.TaxTutar = response.body.TutarBilgileri.TaxTutar
        this.BiletIade.TutarBilgileri.YffTutar = response.body.TutarBilgileri.YFFTutar
        this.BiletIade.TutarBilgileri.IskontoTutar = response.body.TutarBilgileri.IskontoTutar
        this.BiletIade.TutarBilgileri.CezaTutar = response.body.TutarBilgileri.CezaTutar
        this.BiletIade.TutarBilgileri.KaTutar = response.body.TutarBilgileri.KaTutar
        this.BiletIade.TutarBilgileri.DigerServisTutar = response.body.TutarBilgileri.DigerServisTutar
        this.BiletIade.TutarBilgileri.ReserveTutar = response.body.TutarBilgileri.ReserveTutar
        this.SatisSekli = response.body.OdemeBilgileri.SatisSekli

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })

    }

  }

  function dovizTutarTopla() {
    this.BiletIade.TutarBilgileri.NetTutar.NetTutarAlisDoviz = this.BiletIade.TutarBilgileri.Tutar.TutarAlisDoviz +
      this.BiletIade.TutarBilgileri.CezaTutar.CezaAlisTutar + this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz
  }

  function tutarTopla() {

    this.BiletIade.TutarBilgileri.NetTutar.NetTutar =
      this.BiletIade.TutarBilgileri.Tutar.Tutar +
      this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar +
      this.BiletIade.TutarBilgileri.TaxTutar.TaxTutar +
      this.BiletIade.TutarBilgileri.YffTutar.YFFTutar +
      this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar +
      this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar +
      this.BiletIade.TutarBilgileri.IadeServisTutar.IadeServisTutar +
      this.BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar +
      this.BiletIade.TutarBilgileri.KaTutar.KaTutar -
      this.BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar

    this.BiletIade.CezasızTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar - this.BiletIade.TutarBilgileri.CezaTutar
      .CezaTutar

    if (this.BiletIade.TutarBilgileri.Kur > 0) {
      this.BiletIade.TutarBilgileri.NetTutar.NetTutarSatisDoviz = this.BiletIade.TutarBilgileri.NetTutar.NetTutar /
        this.BiletIade.TutarBilgileri.Kur
      this.BiletIade.TutarBilgileri.Tutar.TutarSatisDoviz = this.BiletIade.TutarBilgileri.Tutar.Tutar / this.BiletIade.TutarBilgileri
        .Kur

      this.BiletIade.TutarBilgileri.CezaTutar.CezaSatisTutar = this.BiletIade.TutarBilgileri.CezaTutar.CezaTutar / this
        .BiletIade
        .TutarBilgileri.Kur

      this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz = this.BiletIade.TutarBilgileri.AlanVergiTutar.AlanVergiTutar /
        this.BiletIade.TutarBilgileri.Kur

      this.BiletIade.TutarBilgileri.IskontoTutar.IskontoDoviz = this.BiletIade.TutarBilgileri.IskontoTutar.IskontoTutar /
        this.BiletIade.TutarBilgileri.Kur

      this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisDoviz = this.BiletIade.TutarBilgileri.DigerServisTutar.DigerServisTutar
      this.BiletIade.TutarBilgileri.Kur

      this.BiletIade.TutarBilgileri.ReserveTutar.ReserveDoviz = this.BiletIade.TutarBilgileri.ReserveTutar.ReserveTutar /
        this.BiletIade.TutarBilgileri.Kur


    }




    //   if (this.SatisSekli == 'P') {
    //     this.BiletIade.OdemeBilgileri.PesinTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
    //     this.BiletIade.OdemeBilgileri.PesinDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
    //       .TutarBilgileri.Kur

    //   } else if (this.SatisSekli == 'K') {
    //     this.BiletIade.OdemeBilgileri.KrediliTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
    //     this.BiletIade.OdemeBilgileri.KrediliDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
    //       .TutarBilgileri.Kur
    //   } else {
    //     this.BiletIade.OdemeBilgileri.KrediKartTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar
    //     this.BiletIade.OdemeBilgileri.KrediKartDvzTutar = this.BiletIade.TutarBilgileri.NetTutar.NetTutar / this.BiletIade
    //       .TutarBilgileri.Kur

    //   }

  }

  function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
  }

  function ekle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var current = this.Bilet

        this.$http.post(auth.API_URL + 'api/Current/New', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else if (response.body.Status === false) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      } else {
        this.active = 0;
      }
    })
  }
</script>

<style>
</style>